<template>
    <v-dialog v-bind="$attrs" persistent content-class="modal-dialog__waiting">
        <v-card class="modal-waiting">
            <div
                v-html="require('!html-loader!@/assets/icons/connection.svg')"
                class="connection-animate size-60"
            />
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalWaiting",
}
</script>

<style lang="scss">
.modal-dialog__waiting.v-dialog {
    width: auto;
    box-shadow: none;
}
</style>

<style lang="scss" scoped>
.modal-waiting.v-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: var(--rh-list-background);
    border-radius: 360px;
    box-shadow: 0px 2px 15px 0px rgba(37, 37, 37, 0.10);
    padding: 40px;
    height: 140px;
    width: 140px;
}

.connection-animate {
    animation: scale 1s infinite linear;
}
@keyframes scale {
    0% {
        transform: scaleX(-1);
    }
    50% {
        transform: scaleX(-1);
    }
    51% {
        transform: scaleX(1);
    }
    100% {
        transform: scaleX(1);
    }
}

.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
}
</style>